module.exports = __webpack_public_path__ + "static/media/whatsappIcon.bd96d157.svg";